
<template>
     <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-row>
      <b-col sm="12" md="12">
    
    <b-card>
    <b-col md="12" class="text-left">
        <b-button  @click="regresar()" size="sm" variant="secondary">Listado de actas  </b-button>
    </b-col>
    <br />
     <b-row v-if="cuenta">
      
      
       <b-col md="4">
        <b-form-group >
          <label>No. Cuenta</label>
          <b-form-input  v-model="cuenta.noCuenta" disabled ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Fecha</label>
          <b-form-input v-model="acta.fecha" disabled ></b-form-input>
        </b-form-group>
      </b-col>
     <b-col md="4">
        <b-form-group >
          <label>Folio de acta</label>
          <b-form-input           
            v-model="acta.folio"
            disabled           
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Razón social</label>
          <b-form-input           
            v-model="cuenta.razonSocial"
            disabled
            
          ></b-form-input>
          
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Código Postal</label>
          <b-form-input           
            v-model="cuenta.cp"
            disabled
            
          ></b-form-input>
          
        </b-form-group>
      </b-col>
     <b-col md="4">
        <b-form-group >
          <label>Colonia</label>
          <b-form-input           
            v-model="cuenta.colonia"
            disabled            
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Domicilio</label>
          <b-form-input           
            v-model="cuenta.domicilio"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
     
      <b-col md="4">
        <b-form-group >
          <label>Delegación</label>
          <b-form-input           
            v-model="cuenta.delegacion"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group >
          <label >Giro</label>
          <b-form-input           
            v-model="cuenta.giro"
           disabled
          ></b-form-input>
          
        </b-form-group>
      </b-col>
       <b-col md="6">
        <b-form-group >
          <label >Giro de uso de suelo</label>
          <b-form-input           
            v-model="acta.giroSuelo"
           disabled
          ></b-form-input>
         
        </b-form-group>
      </b-col>
       <b-col md="8">
        <b-form-group >
          <label >Nombre de quién recibe inspección</label>
          <b-form-input           
            v-model="acta.nombreInspeccion"
            disabled
          ></b-form-input>
        
        </b-form-group>
      </b-col>
       <b-col md="4">
         <b-form-group >
          <label >Tipo de identificación</label>
          <b-form-input           
            v-model="acta.tipoIdentificacion"
            disabled
          ></b-form-input>
        
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group >
          <label >No. Identificación</label>
          <b-form-input           
            v-model="acta.noIdentificacion"
          disabled  
          ></b-form-input>
          
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group >
          <label >Puesto</label>
          <b-form-input           
            v-model="acta.puesto"
           disabled
          ></b-form-input>
          
        </b-form-group>
      </b-col>
      <b-col md="12">
        <label >Observaciones</label>
          <b-form-textarea
            v-model="acta.observaciones"
           disabled
           rows="5"
          ></b-form-textarea>
      </b-col>
    </b-row>
         <br />
     <b-list-group sm="12" v-if="acta">
        <b-list-group-item   v-for="testigo, index in acta.testigos" :key="index">
          
          <b-row >
            <b-col md="11" >
            <h4 style="text-align: center" >T E S T I G O </h4>
            </b-col>
        
           </b-row>
          
          <b-col md="12">
            <b-row>
              <b-col md="8">
              <b-form-group >
                <label >Nombre del testigo</label>
                <b-form-input v-model="testigo.nombre" disabled ></b-form-input>
                
              </b-form-group>
            </b-col>
                   <b-col md="4">
              <b-form-group >
                <label>Tipo de identificación</label>
                <b-form-input v-model="testigo.identificacion" disabled ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group >
                <label >No. Identificación</label>
                <b-form-input           
                  v-model="testigo.noIdentificacion"
                 disabled
                ></b-form-input>
               
              </b-form-group>
            </b-col>
            <b-col md="6">
            <b-form-group >
              <label >Puesto</label>
              <b-form-input           
                v-model="testigo.puesto"
              disabled
              ></b-form-input>
             
                
            </b-form-group>
          </b-col>
     
              
            </b-row>
          </b-col>
        </b-list-group-item>
     </b-list-group>
     <br />
     <b-col v-if="recomendaciones.length>0">
      <h4 style="text-align: center" >R E C O M E N D A C I O N E S</h4>
      </b-col>
    <b-list-group sm=12 v-if="acta">
    <b-list-group-item v-for="recomendacion, index in recomendaciones" :key="index">      

      <b-input-group  class="mt-3">
        <b-form-input                   
           
            v-model="recomendacion.texto"
          disabled
        ></b-form-input>
       
      </b-input-group> 
        
    </b-list-group-item> 
    </b-list-group>
    
    <br />

    
  

   
    </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import axios from "axios";
import Loader from "../Loader";
import { mapGetters } from "vuex";
const { DateTime } = require("luxon");
export default {
  name: "acta-view",
  components: { Loader },

  computed: {
    ...mapGetters(["httpURL", "sessionToken", "permisos"]),
    recomendaciones(){
      let lista = []
      if(this.acta.recomendaciones.length>0){
        this.acta.recomendaciones.forEach(element => {
          lista.push({texto:element})
        });
      }
      return lista;
    }
  },
 
  data: function() {
    return {
      enviando: false,
      cuenta:null,
      acta:{
        recomendaciones:[]
      },
      expediente: null
    };
  },
  
  created(){
    if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 218) == -1) this.$router.go(-1);
    this.enviando = true;
    
       
    axios.get(this.httpURL+'/proteccionBomberos/cuenta/'+this.$route.params.idCuenta+'/expediente/acta/'+this.$route.params.idActa,
                {headers:{token:this.sessionToken}})
        .then(res => {
           // console.log(res.data);
            this.expediente=res.data.expediente;
            this.cuenta={
                noCuenta:res.data.cuenta.noCuenta,
                razonSocial:res.data.cuenta.razonSocial,
                cp:res.data.cuenta.cp,
                domicilio:res.data.cuenta.domicilio,
                colonia:res.data.cuenta.colonia,
                delegacion:res.data.cuenta.delegacion,
                giro:res.data.cuenta.giro             
            },
            this.acta={
                       
              fecha: DateTime.fromISO(res.data.acta.fecha).toFormat('dd-MM-yyyy'),
              folio:res.data.acta.folio,
              status:res.data.acta.status,
              
              usuario:res.data.acta.usuario.nombre+' '+res.data.acta.usuario.paterno+' '+res.data.acta.usuario.materno,
              giroSuelo:res.data.acta.giroSuelo,
              nombreInspeccion: res.data.acta.inspeccion.nombre,
              
              tipoIdentificacion: res.data.acta.inspeccion.identificacion,
              noIdentificacion:res.data.acta.inspeccion.noIdentificacion,
              puesto:res.data.acta.inspeccion.puesto,
              observaciones: res.data.acta.observaciones,
              testigos:res.data.acta.testigos,
              recomendaciones:res.data.acta.recomendaciones
            }
            
            this.enviando = false;
        })
        .catch(error => {
          this.enviando = false;
         //console.log(error);
           swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
           this.enviando = false;
        });
    
  },
  
  methods: {
      regresar(){
       this.$router.replace({path: '/proteccionBomberos/cuenta/'+this.$route.params.idCuenta+'/expediente/'+this.expediente+'/actas'});
      }
     
  }
};
</script>

<style >
.error-text {
  color: #ff0000;
}
.invalid_input{
    border: 1px solid red;
}

</style>